import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledSectionBonuses = styled(Styled.Section)`
@media screen and (min-width: 1000px) {
    padding-bottom:290px;
}
`
export const ImageBonuse = styled.img`
  width: 100%;
  height: auto;
`;
